import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { DialogComponent as SyncfusionDialogComponent } from '@syncfusion/ej2-angular-popups';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { GridLocalDataBaseComponent } from 'src/app/base/shared/grid-base/grid-local-data-base.component';
import { DashboardService } from '../../dashboard/dashboard.service';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { TabSettingsWidgetEditFormType } from './tab-settings-edit-form-form-type';
import { CreateDashboardDTO, IDashboardDTO, UpdateDashboardDTO } from 'src/app/base/models/models.swagger.generated';
import { ModalService } from 'src/app/base/shared/modal/modal.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-tab-settings',
    imports: [TranslateModule, DialogModule, DropDownListModule, ReactiveFormsModule, AppErrorMessagesComponent, GridModule, ToolbarModule],
    templateUrl: './tab-settings.component.html',
    styleUrl: './tab-settings.component.scss'
})
export class TabSettingsComponent extends GridLocalDataBaseComponent implements OnInit, OnDestroy {

  @ViewChild('editTabSettingsWidget')
  public tabSettingsDialog: SyncfusionDialogComponent;

  @Output()
  public closeTabSettingsWidget: EventEmitter<void> = new EventEmitter<void>();

  protected editForm: FormGroup<TabSettingsWidgetEditFormType>
  private subscriptions: Subscription = new Subscription();
  private serviceData: IDashboardDTO[];

  constructor(
    translateService: TranslateService,
    private dashboardService: DashboardService,
    private modalService: ModalService,
    private fb: FormBuilder
  ) {
    super(null, translateService, null);
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.dashboardService.dashboards$.subscribe(dashboards => {
        this.serviceData = dashboards;
        this.resetDialog();
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onCloseEditTabSettings(): void {
    this.tabSettingsDialog.hide();
    this.closeTabSettingsWidget.emit();
    this.resetDialog();
  }

  public showEditTabSettings(): void {
    this.resetDialog();
    this.tabSettingsDialog.show();
  }

  public saveTabInfo(): void {
    if (this.editForm.controls.id.value === 0) {
      this.dashboardService.addDashboard(new CreateDashboardDTO({
        name: this.editForm.controls.name.value,
        imageData: this.editForm.controls.image.value,
        tabGroupIndex: this.data.length
      })).subscribe();
    } else {
      this.dashboardService.updateDashboard(new UpdateDashboardDTO({
        id: this.editForm.controls.id.value,
        name: this.editForm.controls.name.value,
        imageData: this.editForm.controls.image.value,
        tabGroupIndex: this.editForm.controls.tabGroupIndex.value
      })).subscribe();
    }
  }

  public deleteTabInfo(): void {
    const dialog = this.modalService.showOkCancelDialog('i18n.domain.home.dashboard.edit-tabs-widget.delete-dashboard-title', 'i18n.domain.home.dashboard.edit-tabs-widget.delete-dashboard-message')
    dialog.onOkSubject.subscribe(() => {
      this.dashboardService.deleteDashboard(this.editForm.controls.id.value).subscribe();
    });
  }

  public onRowSelected(args: any): void {
    this.initForm(args.data.id, args.data.name, args.data.image, args.data.tabGroupIndex);
  }

  public addTab(): void {
    this.initForm(0,'', '',null);
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  private initForm(id: number, name: string, image: string, dashboardIndex: number): void {
    this.editForm = this.fb.group<TabSettingsWidgetEditFormType>({
      id: this.fb.control(id),
      name: this.fb.control(name, [Validators.required]),
      image: this.fb.control(image),
      tabGroupIndex: this.fb.control(dashboardIndex)
    });
  }

  private resetDialog(): void {
    this.editForm = null;
    this.data = this.serviceData;
    this.grid?.refresh();
  }
}

